import React, { PureComponent } from 'react';
import { Grid, Paper } from '@mui/material';

import SamplingParameters from '../common/SamplingParameters';
import MissionInfo from '../common/MissionInfo';
import MissionHeader from '../common/MissionHeader';
import { OnLoading, SettingsAccessLevel } from '../../../types/types';

import {
  CloseMissionButton,
  DownloadCSVButton,
  DownloadKmlButton,
  DownloadPDFButton,
  DownloadShapeButton,
} from '../buttons';
import ShowNotesButton from '../buttons/ShowOperatorNotesButton';
import { downloadXag } from '../../../db_ops/mission_ops';
import UploadXagButton from '../buttons/UploadXagButton';
import { LoadingButton } from '../../utils';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { getCurrentUser } from '../../../dataModelHelpers';
import SkipsProcessingDialog from './SkipsProcessingDialog';

interface MapsMissionLoadedProps {
  onLoading: OnLoading;
  accessLevel: SettingsAccessLevel;
  mapmakingNotesVisible: boolean;
  toggleMapmakingNotes: () => void;
  openExitInterview: () => void;
}

interface MapsMissionLoadedState {
  dialogOpen: boolean;
  skipsDialogOpen: boolean;
}

export default class MapsMissionLoaded extends PureComponent<MapsMissionLoadedProps, MapsMissionLoadedState> {
  constructor(props: MapsMissionLoadedProps) {
    super(props);

    this.state = {
      dialogOpen: false,
      skipsDialogOpen: false,
    };
  }

  render() {
    const currentUser = getCurrentUser();

    if (!currentUser) {
      return null;
    }

    return (
      <Paper style={{ marginTop: 20, maxWidth: '100%', marginBottom: 20 }}>
        <Grid container justifyContent="center" alignItems="center" spacing={2} size={12}>
          <Grid style={{ marginTop: 10, textAlign: 'center' }} size={12}>
            <MissionHeader />
          </Grid>

          <Grid
            container
            spacing={1}
            alignItems="center"
            justifyContent="center"
            style={{ paddingTop: 20, paddingBottom: 20, marginLeft: 12.5 }}
            size={12}
          >
            <Grid>
              <CloseMissionButton openDialog={this.props.openExitInterview} />
            </Grid>

            <Grid>
              <DownloadKmlButton />
            </Grid>

            <Grid>
              <LoadingButton
                variant="outlined"
                onClick={async () => await downloadXag()}
                data-testid="mission-kml-to-xag"
                style={{ marginLeft: 5 }}
              >
                <CloudDownloadIcon style={{ paddingRight: 7.5 }} />
                XAG
              </LoadingButton>
            </Grid>

            <Grid>
              <UploadXagButton onLoading={this.props.onLoading} />
            </Grid>

            <Grid>
              <ShowNotesButton
                isShown={this.props.mapmakingNotesVisible}
                handleClick={this.props.toggleMapmakingNotes}
              />
            </Grid>

            {currentUser.isOpsManager() && (
              <Grid>
                <Grid>
                  <LoadingButton
                    variant="outlined"
                    style={{
                      color: '#cc0000',
                      borderColor: '#cc0000',
                    }}
                    onClick={() => this.setState({ skipsDialogOpen: true })}
                  >
                    Skips Processing
                  </LoadingButton>
                </Grid>
              </Grid>
            )}

            {this.props.accessLevel === 'Technician' && (
              <Grid>
                <DownloadCSVButton />
              </Grid>
            )}

            {this.props.accessLevel === 'Technician' && (
              <Grid>
                <DownloadShapeButton />
              </Grid>
            )}

            {this.props.accessLevel === 'Technician' && (
              <Grid>
                <DownloadPDFButton accessLevel={this.props.accessLevel} />
              </Grid>
            )}
          </Grid>

          <Grid style={{ marginLeft: 18 }} size={12}>
            <SamplingParameters expanded={true} onLoading={this.props.onLoading} mapType="maps" />
          </Grid>

          <Grid style={{ marginLeft: 18, marginBottom: 20 }} size={12}>
            <MissionInfo expanded={true} />
          </Grid>

          {/* <MapsExitInterview
            open={this.state.dialogOpen}
            closeForm={() => this.setState({ dialogOpen: false })}
          /> */}

          <SkipsProcessingDialog
            open={this.state.skipsDialogOpen}
            closeForm={() => this.setState({ skipsDialogOpen: false })}
          />
        </Grid>
      </Paper>
    );
  }
}
